import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Navbar from "./components/Navbar/Navbar";
import Dashboard from "./Dashboard/Dashboard";
import Login from "./Login/Login";
import Signup from "./Signup/Signup";
import ProtectedRoute from "./components/auth/protectedRoute";
import PublicRoute from "./components/auth/publicRoute";
import { AuthProvider } from "./components/auth/authProvider";
import Result from "./Results/Result"
import ResultNew from "./Results/ResultNew";
import SignIn from '../../frontend/src/pages/SignIn/SignIn'
import DashboardNew from "./Results/DashboardNew";

export default function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Toaster position="top-center" />
                {/* <Navbar /> */}
                <Routes>
                    <Route
                        path="/"
                        element={
                            <ProtectedRoute>
                                {/* <ResultNew /> */}
                                <DashboardNew/>
                            </ProtectedRoute>
                        }
                    />
                    
                    <Route
                        path="/login"
                        element={
                            <PublicRoute>
                                {/* <Login /> */}
                                <SignIn/>
                            </PublicRoute>
                        }
                    />
                    <Route
                        path="/signup"
                        element={
                            <PublicRoute>
                                {/* <Signup /> */}
                                <SignIn/>
                            </PublicRoute>
                        }
                    />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}
